export default __webpack_public_path__ + "static/media/1881.26b90914.png";